import { boot } from 'quasar/wrappers'
import axios from 'axios'
import { Notify } from 'quasar'
import getError from '../utils/errors-catalog'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const api = axios.create({ baseURL: process.env.API })

export default boot(({ app, store, router }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API

  api.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response.data.code == 100) {
        let errors = getError(error.response.status, error.response.data.code, error.response.data.fields)
        for (const error of errors) {
          Notify.error(error)
        }
      } else {
        Notify.error(getError(error.response.status, error.response.data.code))
      }
      if (error.response.status == 401) {
        store.dispatch('auth/clear')
        router.push({ name: 'login' })
      }
      return Promise.reject(error)
    }
  )
})

export { api }
